const predefinedDiv = document.querySelector('[data-predefined-prints]');
const customDiv = document.querySelector('[data-custom-prints]');
let buttons = document.querySelectorAll('.prints-button');
if (!predefinedDiv || !customDiv || !buttons.length) return;

buttons = Array.from(buttons);

function toggleContentDisplay(button) {
  const type = button.dataset.buttonType;
  if (!type) return;
  
  if (type === 'predefined') {
    predefinedDiv.classList.remove('hidden');
    customDiv.classList.add('hidden');
    buttons.predefined.setAttribute('data-tab-open', true);
    buttons.custom.removeAttribute('data-tab-open');
  } else if (type === 'custom') {
    predefinedDiv.classList.add('hidden');
    customDiv.classList.remove('hidden');
    buttons.custom.setAttribute('data-tab-open', true);
    buttons.predefined.removeAttribute('data-tab-open');
  }
}

buttons?.forEach(button => {
  button.addEventListener('click', () => toggleContentDisplay(button));
});


buttons = buttons.reduce((obj, currentButton) => {
  obj[currentButton.dataset.buttonType] = currentButton;
  return obj;
}, {});